module.exports = __webpack_public_path__ + "img/md5-hover3.812f5f7f.png";